import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { AdminLoanDocument, EditLoanDocument } from 'graphql/generated/graphql';

const useEditLoan = () => {
  const [loanMutation] = useMutation(EditLoanDocument);

  const handleSubmit = useCallback(
    async (formData: Record<string, unknown>) => {
      try {
        await loanMutation({
          variables: { formData },
          awaitRefetchQueries: true,
          refetchQueries: [AdminLoanDocument],
        });
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [loanMutation],
  );
  return handleSubmit;
};

export default useEditLoan;
